import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import SmartphoneIcon from '@mui/icons-material/Smartphone';
import FormContainer from '../../../core/components/layout/FormContainer';

/**
 * Member web login/signup (phone OTP) is retired — use the mobile app.
 * Paired with killmonger member OTP guards (MEMBER_WEB_OTP_ENABLED).
 */
const MemberWebAuthDisabled: React.FC = () => {
  const theme = useTheme();

  return (
    <FormContainer
      snackBarOpts={{
        useSnackBar: false,
        message: '',
        duration: 6000,
        error: false,
        warning: false,
        sx: {},
      }}
      secondOptionActionText=''
    >
      <Box sx={{ textAlign: 'center', py: 4, px: 2 }}>
        <SmartphoneIcon sx={{ fontSize: 56, color: theme.palette.primary.main, mb: 2 }} />
        <Typography variant='h5' gutterBottom fontWeight={600}>
          Use the MindRight app
        </Typography>
        <Typography variant='body1' color='text.secondary' sx={{ mb: 2, lineHeight: 1.6 }}>
          Sign in and sign up on the web are no longer available. Download the MindRight mobile app
          to continue.
        </Typography>
        <Typography variant='body2' color='text.secondary'>
          Questions?{' '}
          <Typography
            component='a'
            href='mailto:support@mindright.io'
            color='primary'
            sx={{ textDecoration: 'none', fontWeight: 600 }}
          >
            support@mindright.io
          </Typography>
        </Typography>
      </Box>
    </FormContainer>
  );
};

export default MemberWebAuthDisabled;
